import { render, staticRenderFns } from "./rule-edit.vue?vue&type=template&id=30a5cfe2&scoped=true"
import script from "./rule-edit.vue?vue&type=script&lang=js"
export * from "./rule-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a5cfe2",
  null
  
)

export default component.exports